module.exports = __webpack_public_path__ + "static/media/lift.4bdbdb96.svg";